var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": "",
      "max-width": "140"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "py-0 pr-0"
  }, [_vm._v(" 유형 ")])], 1), _c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "dense": "",
      "flat": "",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.query['type'],
      callback: function callback($$v) {
        _vm.$set(_vm.query, 'type', $$v);
      },
      expression: "query['type']"
    }
  }, 'v-select', {
    items: _vm.items
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }